
import { useCallback, useEffect, useRef, useState } from "react"

import { getDictionaries } from "../api/dictionary"

export function useDictionary() {
  const [loading, setLoading] = useState(true)
  const collections = useRef([])
  const fields = useRef([])
  const tags=useRef([])
  const templates = useRef([])

  useEffect(() => {
    if (collections.current.length === 0) {
      getDictionaries().then((result) => {
        console.log("result", result)
        collections.current = result.data.collections
        tags.current = result.data.tags
        templates.current = result.data.templates || []
        fields.current = result.data.fields
        setLoading(false)
      })
    } else {
      setLoading(false)
    }
  }, [])

  const getCollectionByUrn = useCallback(
    (urn) => {
      return collections.current.find((collection) => collection.urn === urn)
    },
    [collections]
  )

  const getFieldByUrn = useCallback(
    (urn) => {
      return fields.current.find((field) => field.urn === urn)
    },
    [fields]
  )

  const getTagByUrn = useCallback(
    (urn) => {
      return tags.current.find((tag) => tag.urn === urn)
    },
    [tags]
  )

  const getTemplateByUrn = useCallback(
    (urn) => {
      return templates.current.find((template) => template.urn === urn)
    },
    [templates]
  )

  return {
    loading,
    getCollectionByUrn,
    getFieldByUrn,
    getTagByUrn,
    getTemplateByUrn
  }
}
